import { Flex } from 'components/Flex';
import { P } from 'components/Typography/Typography';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';

export const CompanyList = styled(Flex)`
  flex-direction: column;
  gap: 0;
`;

export const CompanyItem = styled(Flex)<{ isSelected?: boolean }>`
  padding: 12px 20px;
  border-bottom: 1px solid ${({ theme }) => theme.palette.neutral.medium};
  cursor: pointer;
  transition: background-color 0.15s ease;
  background-color: ${({ theme, isSelected }) =>
    isSelected ? theme.palette.accent.veryLightBlue : theme.palette.neutral.white};
  
  &:hover {
    background-color: ${({ theme }) => theme.palette.accent.veryLightBlue};
  }
  
  &:last-child {
    border-bottom: none;
  }
`;

export const CompanyName = styled(P)`
  margin: 0;
  font-weight: 500;
`;

export const CompanyInfo = styled(P)`
  margin: 4px 0 0 0;
  color: ${({ theme }) => theme.palette.neutral.grey};
  font-size: 14px;
`;

export const DefaultBadge = styled(P)`
  margin-left: 8px;
  padding: 2px 8px;
  background-color: ${({ theme }) => theme.palette.accent.steelBlue};
  color: white;
  border-radius: 4px;
  font-size: 11px;
`;

export const SelectedIcon = styled(FontAwesomeIcon)`
  color: ${({ theme }) => theme.palette.accent.blue};
  font-size: 16px;
`;

export const EmptyState = styled(Flex)`
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
`;
